import { render, staticRenderFns } from "./credenciais.vue?vue&type=template&id=7e353282&"
import script from "./credenciais.vue?vue&type=script&lang=ts&"
export * from "./credenciais.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports